import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section">
          <h3>Ferupen Barbershop</h3>
          <p>
            Το premium barbershop σας στην Ελλάδα. Προσφέρουμε εξαιρετικά
            προϊόντα περιποίησης για τον σύγχρονο κύριο που εκτιμά την κομψότητα
            και την ποιότητα.
          </p>
          <p>
            <strong>ΑΦΜ:</strong> 87657353
          </p>
        </div>

        <div className="footer-section">
          <h3>Γρήγορες Συνδέσεις</h3>
          <ul>
            <li>
              <Link to="/">Αρχική</Link>
            </li>
            <li>
              <Link to="/about">Σχετικά με εμάς</Link>
            </li>
            <li>
              <Link to="/contact">Επικοινωνία</Link>
            </li>
            <li>
              <Link to="/cart">Καλάθι Αγορών</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Επικοινωνία</h3>
          <p>Ermou 36</p>
          <p>Markopoulo Mesogeas 190 03</p>
          <p>Ελλάδα</p>
          <p>Τηλέφωνο: +302299022996</p>
          <p>
            <a className="footer_link" href="https://wa.me/302299022996">WhatsApp</a>
          </p>
          <p>
            <a className="footer_link" href="https://viber.me/302299022996">Viber</a>
          </p>
          <a className="footer_link" href="mailto:ferupen@hotmail.com">ferupen@hotmail.com</a>
        </div>

        <div className="footer-section">
          <h3>Νομικά</h3>
          <ul>
            <li>
              <Link to="/privacy-policy">Πολιτική Απορρήτου</Link>
            </li>
            <li>
              <Link to="/terms-conditions">Όροι Χρήσης</Link>
            </li>
            <li>
              <Link to="/refund-policy">Πολιτική Επιστροφών</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2026 Ferupen Barbershop. Όλα τα δικαιώματα κατοχυρωμένα.</p>
        <div className="footer-links">
          <Link to="/privacy-policy">Πολιτική Απορρήτου</Link>
          <Link to="/terms-conditions">Όροι Χρήσης</Link>
          <Link to="/refund-policy">Πολιτική Επιστροφών</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
